import React, { useRef, useState, useEffect } from "react";
import { Box } from "@mui/material";
import screenBg from '../style/img/damier.avif';

const SmallScreenPreview = ({ name, view, url, rendererId, preview, debug, rendererLink  }) => {
  // OPUS-913 perf: only mount the live broker <iframe> once the card scrolls into
  // view (with a 200px pre-load margin), and keep it mounted after the first
  // reveal. Mounting one live confidence feed per renderer up-front was the
  // biggest source of grid/preview-view jank.
  const holderRef = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (visible) return undefined;
    const el = holderRef.current;
    if (!el || typeof IntersectionObserver === "undefined") { setVisible(true); return undefined; }
    const obs = new IntersectionObserver(
      (entries) => { if (entries.some((e) => e.isIntersecting)) { setVisible(true); obs.disconnect(); } },
      { rootMargin: "200px" },
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [visible]);

  return (
    <Box sx={{backgroundColor:'#000000', borderRadius:'1', padding:'.3em', height:'fit-content', border:'1px solid #CCCCCC50'}}>

      <div ref={holderRef} style={{ width: '100%', position: 'relative', aspectRatio: '16/9' }}>
        {visible ? (
          <iframe
            src={`https://${url}/?renderer=${rendererId}${preview ? '' : ''}&debug=${debug}`}
            style={{
              border: "none",
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
              backgroundImage: `url(${screenBg})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
            title="Confidence feed"
          />
        ) : (
          <div
            style={{
              width: '100%',
              height: '100%',
              position: 'absolute',
              top: 0,
              left: 0,
              backgroundImage: `url(${screenBg})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
        )}
        {view === 'gridView' && <div style={{background:'#00000080', position:'absolute',    bottom: '0', left: '50%', transform: 'translateX(-50%)', zIndex:100, width:'100%', textAlign:'center', fontWeight:'bold'}}>{rendererId}</div>}
      </div>

    </Box>
  );
};

export default SmallScreenPreview;
